import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  de: {
    translation: {
      'app.title': 'CV Optimizer',
      'app.description': 'Lade deinen CV hoch und erhalte eine optimierte Version basierend auf der Stellenbeschreibung.',
      'upload.cv': 'CV hochladen',
      'upload.job': 'Stellenbeschreibung hochladen',
      'upload.job.description': 'Lade eine Stellenbeschreibung hoch oder gib sie manuell ein',
      'job.description': 'Stellenbeschreibung',
      'job.description.placeholder': 'Beschreibe die Stelle, für die du dich bewirbst...',
      'analyze': 'Analysieren',
      'download.original': 'Original CV herunterladen',
      'download.improved': 'Verbesserter CV herunterladen',
      'download.motivation': 'Motivationsschreiben herunterladen',
      'match.score': 'Übereinstimmung',
      'missing.skills': 'Fehlende Fähigkeiten',
      'improved.cv': 'Verbesserter CV',
      'motivation.letter': 'Motivationsschreiben',
      'loading': 'Lädt...',
      'error.upload': 'Fehler beim Hochladen',
      'error.analyze': 'Fehler bei der Analyse',
      'error.download': 'Fehler beim Herunterladen',
      'error.backend.api': 'Backend API URL nicht konfiguriert',
      'error.extract.cv': 'Fehler beim Extrahieren des CV-Texts',
      'error.extract.cv.unknown': 'Unbekannter Fehler beim Extrahieren des CV-Texts: ',
      'cv.original.text': 'Originaler CV Text',
      'cv.personal.info': 'Persönliche Angaben',
      'cv.tab.data': 'CV Daten',
      'cv.tab.start': 'Bewerbungen',
      'cv.tab.job.description': 'Stellenbeschreibung',
      'cv.tab.optimization': 'Optimierung',
      'cv.subtab.applications': 'Bewerbungen',
      'cv.subtab.job.description': 'Stellenbeschreibung',
      'cv.subtab.optimization': 'Optimierung',
      'button.next': 'Weiter',
      'button.back.to.applications': 'Zurück zu meinen Bewerbungen',
      'button.enter.job.description': 'Stellenbeschreibung erfassen',
             'cv.personal.fullname': 'Vollständiger Name',
       'cv.personal.company': 'Firma',
       'cv.personal.address': 'Adresse',
       'cv.personal.postal.code': 'Postleitzahl',
       'cv.personal.city': 'Ort',
       'cv.personal.phone': 'Telefonnummer',
      'cv.personal.email': 'E-Mail-Adresse',
      'cv.personal.birthyear': 'Jahrgang',
             'cv.personal.nationality': 'Nationalität',
       'cv.personal.nationality.select': 'Bitte wählen...',
       'cv.personal.nationality.swiss': 'Schweizer/in',
       'cv.personal.nationality.german': 'Deutsche/r',
       'cv.personal.nationality.austrian': 'Österreicher/in',
       'cv.personal.nationality.french': 'Franzose/in',
       'cv.personal.nationality.italian': 'Italiener/in',
       'cv.personal.nationality.spanish': 'Spanier/in',
       'cv.personal.nationality.british': 'Brite/in',
       'cv.personal.nationality.american': 'Amerikaner/in',
       'cv.personal.nationality.canadian': 'Kanadier/in',
       'cv.personal.nationality.australian': 'Australier/in',
       'cv.personal.nationality.japanese': 'Japaner/in',
       'cv.personal.nationality.chinese': 'Chinese/in',
       'cv.personal.nationality.indian': 'Inder/in',
       'cv.personal.nationality.brazilian': 'Brasilianer/in',
       'cv.personal.nationality.argentinian': 'Argentinier/in',
       'cv.personal.nationality.mexican': 'Mexikaner/in',
       'cv.personal.nationality.russian': 'Russe/Russin',
       'cv.personal.nationality.turkish': 'Türke/Türkin',
       'cv.personal.nationality.moroccan': 'Marokkaner/in',
       'cv.personal.nationality.egyptian': 'Ägypter/in',
       'cv.personal.nationality.south-african': 'Südafrikaner/in',
       'cv.personal.nationality.nigerian': 'Nigerianer/in',
       'cv.personal.nationality.kenyan': 'Keniaer/in',
       'cv.personal.nationality.other': 'Andere',
       'cv.personal.permit': 'Aufenthaltsbewilligung',
       'cv.personal.permit.select': 'Bitte wählen...',
       'cv.personal.civilstatus': 'Zivilstand',
       'cv.personal.civilstatus.select': 'Bitte wählen...',
       'cv.personal.civilstatus.single': 'Ledig',
       'cv.personal.civilstatus.married': 'Verheiratet',
       'cv.personal.civilstatus.divorced': 'Geschieden',
       'cv.personal.civilstatus.widowed': 'Verwitwet',
       'cv.personal.civilstatus.registered-partnership': 'Eingetragene Partnerschaft',
       'cv.personal.profile.picture': 'Profilbild',
       'cv.personal.profile.upload': 'Bild hochladen',
       'cv.personal.profile.format': 'JPG, PNG (max. 2MB)',
      'cv.short.profile': 'Kurzprofil',
      'cv.work.experience': 'Berufserfahrung',
      'cv.education': 'Ausbildung',
      'cv.certificates': 'Weiterbildung / Zertifikate',
      'cv.languages': 'Sprachkenntnisse',
      'cv.languages.language': 'Sprache',
      'cv.languages.level': 'Niveau',
      'cv.languages.level.select': 'Niveau wählen',
      'cv.languages.level.A1': 'A1 - Anfänger',
      'cv.languages.level.A2': 'A2 - Grundlegende Kenntnisse',
      'cv.languages.level.B1': 'B1 - Fortgeschrittene Sprachverwendung',
      'cv.languages.level.B2': 'B2 - Selbständige Sprachverwendung',
      'cv.languages.level.C1': 'C1 - Fachkundige Sprachkenntnisse',
      'cv.languages.level.C2': 'C2 - Annähernd muttersprachlich',
      'cv.languages.level.native': 'Muttersprache',
      'cv.it.skills': 'IT-Kenntnisse',
      'cv.it.skills.skill': 'Skill',
      'cv.it.skills.level': 'Niveau',
      'cv.it.skills.level.select': 'Niveau wählen',
      'cv.it.skills.level.beginner': 'Anfänger',
      'cv.it.skills.level.intermediate': 'Fortgeschritten',
      'cv.it.skills.level.professional': 'Profi',
      'cv.it.skills.level.expert': 'Experte',
      'cv.additional.info': 'Weitere Angaben',
      'language.select': 'Sprache',
      'login.title': 'Anmelden',
      'login.email': 'E-Mail',
      'login.password': 'Passwort',
      'login.submit': 'Anmelden',
      'login.google': 'Mit Google anmelden',
      'login.tab.login': 'Anmelden',
      'login.tab.register': 'Registrieren',
      'login.password.confirm': 'Passwort bestätigen',
      'login.password.mismatch': 'Passwörter stimmen nicht überein',
      'login.password.too.short': 'Passwort muss mindestens 6 Zeichen lang sein',
      'login.password.requirements': 'Mindestens 6 Zeichen erforderlich',
      'login.password.strength': 'Passwort-Stärke',
      'login.password.min.length': 'Mindestens 6 Zeichen',
      'login.password.recommended': '8+ Zeichen (empfohlen)',
      'login.registering': 'Registrieren...',
      'login.logging.in': 'Anmelden...',
      'login.google.logging.in': 'Google Anmelden...',
      'login.register.button': 'Registrieren',
      'login.error.registration': 'Registrierung fehlgeschlagen',
      'login.error.login': 'Login fehlgeschlagen',
      'login.error.google': 'Google Login fehlgeschlagen',
      'login.error.invalid.email': 'Bitte gib eine gültige E-Mail-Adresse ein.',
      'login.error.login.credentials': 'E-Mail oder Passwort ist falsch.',
      'login.error.register.email.in.use': 'Diese E-Mail-Adresse wird bereits verwendet. Bitte melde dich an oder nutze Passwort vergessen.',
      'login.error.register.weak.password': 'Das Passwort ist zu schwach. Bitte verwende mindestens 6 Zeichen.',
      'login.error.too.many.requests': 'Zu viele Versuche. Bitte warte kurz und versuche es erneut.',
      'login.error.network': 'Netzwerkfehler. Bitte prüfe deine Internetverbindung und versuche es erneut.',
      'login.error.google.popup.closed': 'Google-Anmeldung abgebrochen. Das Fenster wurde geschlossen.',
      'login.error.google.popup.blocked': 'Google-Popup wurde blockiert. Bitte erlaube Popups für diese Seite.',
      'login.error.google.popup.cancelled': 'Google-Anmeldung wurde abgebrochen. Bitte versuche es erneut.',
      'login.error.google.unauthorized.domain': 'Diese Domain ist für Google-Anmeldung nicht freigeschaltet.',
      'login.error.google.invalid.continue.uri': 'Google-Anmeldung ist derzeit nicht korrekt konfiguriert (Continue-URI).',
      'login.error.operation.not.allowed': 'Diese Anmeldeart ist aktuell nicht aktiviert.',
      'login.verification.sent.title': 'Registrierung erfolgreich!',
      'login.verification.sent.message': 'Eine Verifizierungs-Email wurde an {{email}} gesendet. Bitte überprüfe dein Postfach und klicke auf den Bestätigungslink.',
      'login.verification.spam.warning': 'Wichtig: Prüfe auch deinen SPAM-ORDNER!',
      'login.verification.after.message': 'Nach der Verifizierung kannst du dich mit deinen Zugangsdaten anmelden.',
      'login.verification.resend.button': 'Email erneut senden',
      'login.verification.resending': 'Sende...',
      'login.verification.resend.success': 'Verifizierungs-Email wurde erneut gesendet! Prüfe auch deinen Spam-Ordner.',
      'login.verification.resend.error': 'Fehler beim erneuten Senden der Email. Bitte überprüfe dein Passwort.',
      'login.verification.password.prompt': 'Bitte gib dein Passwort ein, um die Email erneut zu senden:',
      'login.verification.required': 'Bitte verifiziere zuerst deine Email-Adresse. Prüfe dein Postfach.',
      'login.forgot.password': 'Passwort vergessen?',
      'login.reset.title': 'Passwort zurücksetzen',
      'login.reset.info': 'Gib deine E‑Mail ein. Falls ein Konto existiert, senden wir dir Anweisungen zu.',
      'login.reset.sent': 'Wenn ein Konto existiert, haben wir dir eine E‑Mail gesendet.',
      'login.reset.submit': 'E‑Mail senden',
      'login.reset.new.title': 'Neues Passwort festlegen',
      'login.reset.new.info': 'Gib dein neues Passwort ein.',
      'login.reset.new.password': 'Neues Passwort',
      'login.reset.new.confirm': 'Passwort bestätigen',
      'login.reset.new.submit': 'Passwort speichern',
      'login.reset.new.success': 'Dein Passwort wurde erfolgreich geändert. Du kannst dich jetzt anmelden.',
      'login.reset.new.error': 'Der Link ist ungültig oder abgelaufen. Bitte fordere einen neuen Link an.',
      'login.reset.new.mismatch': 'Passwörter stimmen nicht überein.',
      'login.reset.new.too.short': 'Passwort muss mindestens 6 Zeichen lang sein.',
      'login.reset.new.to.login': 'Zur Anmeldung',
      'common.cancel': 'Abbrechen',
      'logout': 'Abmelden',
      'account': 'Konto',
      'account.plan': 'Preisplan',
      'account.type': 'Account-Typ',
      'account.type.free': 'Free',
      'account.type.basic': 'Basic',
      'account.type.pro': 'Pro',
      'account.type.beta.testing': 'Beta-Testing',
      'account.unlimited.users': 'Unbegrenzt Benutzer',
      'account.unlimited.cv.data.sets': 'Unbegrenzt CV-Daten-Sets',
      'account.save': 'Schliessen',
      'account.saving': 'Speichern...',
      'account.save.success': 'Account-Typ erfolgreich gespeichert',
      'account.save.error': 'Fehler beim Speichern des Account-Typs',
      'account.limit.users.reached': 'Das Benutzerlimit für deinen Account-Typ wurde erreicht. Maximal {max} Benutzer erlaubt.',
      'account.limit.cvs.reached': 'Das CV-Daten-Set-Limit für deinen Account-Typ wurde erreicht. Maximal {max} CV-Daten-Sets erlaubt.',
      'account.type.change.too.many.users': 'Du kannst nicht auf {planType} wechseln, da du aktuell {currentUsers} Benutzer hast. Der {planType}-Plan erlaubt maximal {maxUsers} Benutzer. Bitte entferne zuerst {removeCount} Benutzer.',
      'account.type.change.too.many.cvs': 'Du kannst nicht auf {planType} wechseln, da du aktuell {currentCvs} CV-Daten-Sets hast. Der {planType}-Plan erlaubt maximal {maxCvs} CV-Daten-Sets. Bitte entferne zuerst {removeCount} CV-Daten-Set(s).',
      'account.pdf.download.not.available.free': 'PDF-Download ist im Free-Plan nicht verfügbar. Bitte upgrade auf Basic oder Pro.',
      'account.pdf.downloads': 'PDF-Downloads',
      'account.pdf.downloads.not.included': 'Keine PDF-Downloads',
      'account.pdf.downloads.included': 'PDF-Downloads inklusive',
      'account.subscription.until': 'Laufzeit bis',
      'account.subscription.cancels': 'Kündigt am',
      'account.subscription.cancelled': 'Gekündigt',
      'account.subscription.auto.renew': 'Verlängert sich automatisch',
      'account.upgrade.title': 'Preisplan upgraden',
      'account.upgrade.message': 'PDF-Downloads sind im Free-Plan nicht verfügbar',
      'account.upgrade.description': 'Bitte upgrade auf Basic oder Pro, um PDF-Downloads zu nutzen.',
      'account.upgrade.limit.title': 'PDF Limite aufgebraucht',
      'account.upgrade.limit.message': 'Ihr PDF-Limit wurde erreicht.',
      'account.upgrade.limit.description': 'Bitte warten Sie bis zur nächsten Abrechnungsperiode oder wechseln Sie auf einen höheren Plan.',
      'account.upgrade.button': 'Zum Konto',
      'account.cv.data.sets': 'CV-Daten-Sets',
      'cv.current.dataset.tooltip': 'Dies ist das aktuelle Daten-Set',
      'cv.share.save.and.approve': 'Speichern und freigeben',
      'cv.share.saving': 'Speichern...',
      'cv.share.saved': 'Daten wurden gespeichert',
      'account.users': 'Benutzer',
      'account.users.loading': 'Lade Benutzer...',
      'account.users.none': 'Keine Benutzer gefunden',
      'account.users.email': 'E-Mail',
      'account.users.role': 'Rolle',
      'application.responsible.person': 'Verantwortliche Person',
      'account.users.role.owner': 'Besitzer',
      'account.users.role.member': 'Mitglied',
      'account.users.role.change.promote': 'Zu Besitzer machen',
      'account.users.role.change.demote': 'Besitzerstatus entfernen',
      'account.users.role.change.confirm.promote': 'Möchtest du diesen Benutzer zum Besitzer machen?',
      'account.users.role.change.confirm.demote': 'Möchtest du diesem Besitzer den Besitzerstatus entfernen?',
      'account.users.role.change.success.promote': 'Benutzer wurde zum Besitzer gemacht',
      'account.users.role.change.success.demote': 'Besitzerstatus wurde entfernt',
      'account.users.role.change.error': 'Fehler beim Ändern der Benutzerrolle',
      'account.users.role.change.last.owner.error': 'Der letzte Besitzer kann nicht herabgestuft werden',
      'account.invite': 'Benutzer einladen',
      'account.invite.email': 'E-Mail-Adresse',
      'account.name': 'Account-Name',
      'account.name.placeholder': 'z.B. Meine Firma',
      'account.invite.email.placeholder': 'email@beispiel.com',
      'account.invite.send': 'Einladung senden',
      'account.invite.sending': 'Sende Einladung...',
      'account.invite.success': 'Einladung wurde gesendet',
      'account.invite.error': 'Fehler beim Senden der Einladung',
      'account.invite.invalid.email': 'Ungültige E-Mail-Adresse',
      'account.invite.email.not.sent': 'E-Mail konnte nicht automatisch versendet werden. Bitte kopiere den Link und sende ihn manuell:',
      'account.invite.link': 'Einladungslink',
      'account.invite.copy': 'Kopieren',
      'account.invite.link.copied': 'Link wurde in die Zwischenablage kopiert',
      'account.invite.open.email': 'E-Mail öffnen',
      'account.invite.email.subject': 'Einladung zu Curiculum Account',
      'account.invite.email.body': 'Du wurdest zu einem Curiculum Account eingeladen.\n\nKlicke auf den folgenden Link, um dich zu registrieren und dem Account beizutreten:\n{link}\n\nDieser Link ist 7 Tage gültig.',
      'account.invite.link.not.available': 'Fehler: Einladungslink konnte nicht erstellt werden. Bitte versuche es erneut.',
      'account.users.delete': 'Löschen',
      'account.users.delete.confirm': 'Möchtest du diesen Benutzer wirklich entfernen?',
      'account.users.delete.success': 'Benutzer wurde erfolgreich entfernt',
      'account.users.delete.error': 'Fehler beim Entfernen des Benutzers',
      'account.users.delete.deleting': 'Entferne Benutzer...',
      'invite.title': 'Account-Einladung',
      'invite.message': 'Du wurdest zu {{accountName}} eingeladen. Bitte registriere dich, um dem Account beizutreten.',
      'invite.loading': 'Lade Einladungsdaten...',
      'invite.invalid': 'Ungültiger oder abgelaufener Einladungslink',
      'invite.error.loading': 'Fehler beim Laden der Einladungsdaten',
      'invite.error.register': 'Fehler bei der Registrierung',
      'invite.error.accept': 'Fehler beim Akzeptieren der Einladung',
      'invite.error.google': 'Fehler bei der Google-Registrierung',
      'invite.error.email.mismatch': 'Die Google-E-Mail-Adresse stimmt nicht mit der Einladungs-E-Mail überein',
      'invite.success': 'Registrierung erfolgreich! Du wirst weitergeleitet...',
      'invite.redirecting': 'Weiterleitung...',
      'invite.register': 'Registrieren',
      'invite.registering': 'Registriere...',
      'invite.tab.email': 'E-Mail & Passwort',
      'invite.tab.google': 'Mit Google',
      'invite.email.info': 'Bitte verwende die E-Mail-Adresse {{email}} für die Registrierung.',
      'invite.logged.in': 'Du bist bereits als {{email}} eingeloggt.',
      'invite.accept': 'Einladung akzeptieren',
      'invite.accepting': 'Akzeptiere...',
       'clear.all.data': 'Alle Daten löschen',
       'error.clear.data': 'Fehler beim Löschen der Daten: ',
       'Daten speichern': 'Daten speichern',
       'Keine Änderungen zum Speichern': 'Keine Änderungen zum Speichern',
       'ai.extraction.title': 'KI-gestützte Extraktion',
       'ai.extraction.description': 'Persönliche Daten werden automatisch mit KI extrahiert',
       'ai.extraction.fallback': 'KI-Extraktion fehlgeschlagen, verwende lokale Extraktion',
       'error.ai.extraction': 'Fehler bei der KI-Extraktion: ',
       'extraction.uploading': 'Datei wird hochgeladen...',
       'extraction.processing': 'CV wird verarbeitet...',
       'extraction.short.profile': 'Kurzprofil wird extrahiert...',
       'extraction.work.experience': 'Berufserfahrung wird extrahiert...',
       'extraction.education': 'Ausbildung wird extrahiert...',
       'extraction.certifications': 'Zertifikate werden extrahiert...',
              'extraction.personal.info': 'Persönliche Angaben werden extrahiert...',
       'extraction.fallback': 'Lokale Extraktion wird verwendet...',
       'extraction.complete': 'Extraktion abgeschlossen!',
       'cv.work.experience.add': 'Arbeitserfahrung hinzufügen',
      'cv.work.experience.period': 'Zeitraum',
      'cv.work.experience.company': 'Firma',
      'cv.work.experience.position': 'Position',
      'cv.education.add': 'Ausbildung hinzufügen',
      'cv.education.institution': 'Institution',
      'cv.education.degree': 'Abschluss',
      'cv.certification.add': 'Zertifizierung / Weiterbildung hinzufügen',
      'cv.certification.name': 'Name',
      'cv.certification.issuer': 'Aussteller',
      'cv.certification.date': 'Datum',
      'cv.certification.description': 'Beschreibung',
      'cv.certification.title': 'Zertifizierung / Weiterbildung',
      'cv.certification.extracted': 'Extrahierte Zertifizierungen',
      'button.cancel': 'Abbrechen',
      'button.add': 'Hinzufügen',
      'button.delete': 'Löschen',
      'label.start': 'Start',
      'label.end': 'Ende',
      "cv.education.title": "Ausbildung",
      "cv.education.startDate": "Startdatum",
      "cv.education.endDate": "Enddatum",
      'agb.title': 'Allgemeine Geschäftsbedingungen',
      'agb.welcome': 'Willkommen! Bitte lies und akzeptiere unsere Allgemeinen Geschäftsbedingungen, um die Anwendung nutzen zu können.',
      'agb.readInstructions': 'Bitte lies die AGBs sorgfältig durch:',
      'agb.link': 'AGBs öffnen (in neuem Tab)',
      'agb.confirmation': 'Ich habe die AGBs gelesen und akzeptiere sie.',
      'agb.confirmation.before': 'Ich habe die',
      'agb.confirmation.link': 'AGBs',
      'agb.confirmation.after': 'gelesen und akzeptiere sie.',
      'agb.notice': 'Hinweis: Du musst die AGBs akzeptieren, um die Anwendung nutzen zu können. Du kannst dich jederzeit ausloggen.',
      'agb.logout': 'Ausloggen',
      'agb.accept': 'AGBs akzeptieren',
      'footer.copyright': '© {{year}} acceler-8. Alle Rechte vorbehalten.',
      'footer.impressum': 'Impressum',
      'footer.privacy': 'Datenschutz',
      'footer.terms': 'AGB',
      'impressum.title': 'Impressum',
      'impressum.email': 'E-Mail',
      'impressum.registry': 'Handelsregister-Nr.',
      'impressum.country': 'Schweiz',
      'impressum.back': 'Zur Startseite',
      'agb.accepting': 'Akzeptiere...',
      'agb.error.loading': 'Fehler beim Laden des AGB-Status',
      'agb.error.retry': 'Bitte versuche es erneut oder kontaktiere den Support.',
      'agb.error.reload': 'Seite neu laden',
      'cv.import.warning.title': 'Wichtiger Hinweis zur Datenqualität',
      'cv.import.warning.message': 'Bitte überprüfe die extrahierten Daten sorgfältig!',
      'cv.import.warning.description': 'Die KI-basierte Extraktion von CV-Daten erreicht keine 100%ige Genauigkeit. Es können Fehler bei der Erkennung von:',
      'cv.import.warning.item1': 'Namen, Adressen und Kontaktdaten',
      'cv.import.warning.item2': 'Berufserfahrungen und Zeiträumen',
      'cv.import.warning.item3': 'Ausbildungen und Zertifizierungen',
      'cv.import.warning.item4': 'Fähigkeiten und Kompetenzen',
      'cv.import.warning.footer': 'Bitte korrigiere alle erkannten Fehler, bevor du mit der Bewerbung fortfährst.',
      'cv.import.warning.button': 'Schliessen',
      'cv.import.warning.dontShowAgain': 'Diese Information nicht mehr zeigen.',
      'cv.template.warning.title': 'Wichtiger Hinweis zum optimierten CV',
      'cv.template.warning.message': 'Bitte lies den CV-Entwurf genau durch und passe ihn an!',
      'cv.template.warning.description': 'Die KI erstellt nur einen ersten Entwurf. Du musst den Feinschliff machen und folgende Bereiche überprüfen:',
      'cv.template.warning.item1': 'Formatierung und Layout',
      'cv.template.warning.item2': 'Korrektheit der Informationen',
      'cv.template.warning.item3': 'Relevanz für die Stellenausschreibung',
      'cv.template.warning.disclaimer': 'KI-generierte Inhalte sind Entwürfe und müssen vor Verwendung fachlich geprüft werden. Es wird keine Gewähr für Vollständigkeit, Richtigkeit oder Erfolg übernommen.',
      'cv.template.warning.footer': 'Nimm dir Zeit für eine sorgfältige Überarbeitung, bevor du den CV verwendest.',
      'cv.template.warning.button': 'Schliessen',
      'cv.template.warning.dontShowAgain': 'Diese Information nicht mehr zeigen.',
      'cv.motivation.warning.title': 'Wichtiger Hinweis zum Motivationsschreiben',
      'cv.motivation.warning.message': 'Bitte lies das Motivationsschreiben genau durch und passe es an!',
      'cv.motivation.warning.description': 'Die KI erstellt nur einen ersten Entwurf. Du musst den Feinschliff machen und folgende Bereiche überprüfen:',
      'cv.motivation.warning.item1': 'Rechtschreibung und Grammatik',
      'cv.motivation.warning.item2': 'Persönliche Ansprache und Ton',
      'cv.motivation.warning.item3': 'Relevanz für die Stellenausschreibung',
      'cv.motivation.warning.item4': 'Vollständigkeit der Argumente',
      'cv.motivation.warning.footer': 'Nimm dir Zeit für eine sorgfältige Überarbeitung, bevor du das Motivationsschreiben verwendest.',
      'cv.motivation.warning.button': 'Schliessen',
      'cv.motivation.warning.dontShowAgain': 'Diese Information nicht mehr zeigen.',
      'onboarding.title': 'Willkommen! Bitte vervollständige dein Profil',
      'onboarding.firstName': 'Vorname',
      'onboarding.lastName': 'Nachname',
      'onboarding.gender': 'Geschlecht',
      'onboarding.gender.male': 'Männlich',
      'onboarding.gender.female': 'Weiblich',
      'onboarding.gender.diverse': 'Divers',
      'onboarding.gender.unspecified': 'Keine Angabe',
      'onboarding.country': 'Land',
      'onboarding.country.ch': 'CH - Schweiz',
      'onboarding.country.de': 'DE - Deutschland',
      'onboarding.country.at': 'AT - Österreich',
      'onboarding.country.fr': 'FR - Frankreich',
      'onboarding.country.it': 'IT - Italien',
      'onboarding.company': 'Firma (Optional)',
      'onboarding.save': 'Speichern',
      'onboarding.saving': 'Speichern...',
      'cv.image.upload.title.header': 'Header-Grafik auswählen',
      'cv.image.upload.title.column': 'Spalten-Grafik auswählen',
      'cv.image.upload.maxSize': 'Maximale Grafikgröße:',
      'cv.image.upload.maxSize.header': 'Header-Grafik: Maximal 794 Pixel (Breite) x 228 Pixel (Höhe)',
      'cv.image.upload.maxSize.column': 'Spalten-Grafik: Maximal 318 Pixel (Breite) x 1123 Pixel (Höhe)',
      'cv.image.upload.info': 'Bitte wähle eine Grafik aus, die diese Abmessungen nicht überschreitet.',
      'cv.image.upload.alignment': 'Die Grafik wird links und oben ausgerichtet.',
      'cv.image.upload.select': 'Grafik auswählen',
      'cv.image.upload.error.tooLarge': 'Bild zu groß! Maximale Größe: {{maxWidth}}x{{maxHeight}} Pixel. Dein Bild: {{width}}x{{height}} Pixel',
      'Passgenauigkeit akzeptieren': 'Passgenauigkeit akzeptieren',
      'CV-Vorschau öffnen': 'CV-Vorschau öffnen',
      'Erstellungsdatum': 'Erstellungsdatum',
    }
  },
  fr: {
    translation: {
      'app.title': 'Optimiseur de CV',
      'app.description': 'Téléchargez votre CV et obtenez une version optimisée basée sur la description du poste.',
      'upload.cv': 'Télécharger CV',
      'upload.job': 'Télécharger description de poste',
      'upload.job.description': 'Téléchargez une description de poste ou saisissez-la manuellement',
      'job.description': 'Description du poste',
      'job.description.placeholder': 'Décrivez le poste pour lequel vous postulez...',
      'analyze': 'Analyser',
      'download.original': 'Télécharger CV original',
      'download.improved': 'Télécharger CV amélioré',
      'download.motivation': 'Télécharger lettre de motivation',
      'match.score': 'Score de correspondance',
      'missing.skills': 'Compétences manquantes',
      'improved.cv': 'CV amélioré',
      'motivation.letter': 'Lettre de motivation',
      'loading': 'Chargement...',
      'error.upload': 'Erreur lors du téléchargement',
      'error.analyze': 'Erreur lors de l\'analyse',
      'error.download': 'Erreur lors du téléchargement',
      'error.backend.api': 'URL API backend non configurée',
      'error.extract.cv': 'Erreur lors de l\'extraction du texte du CV',
      'error.extract.cv.unknown': 'Erreur inconnue lors de l\'extraction du texte du CV: ',
      'cv.original.text': 'Texte CV original',
      'cv.personal.info': 'Informations personnelles',
      'cv.tab.data': 'Données CV',
      'cv.tab.start': 'Candidatures',
      'cv.tab.job.description': 'Description du poste',
      'cv.tab.optimization': 'Optimisation',
      'cv.subtab.applications': 'Candidatures',
      'cv.subtab.job.description': 'Description du poste',
      'cv.subtab.optimization': 'Optimisation',
      'button.next': 'Continuer',
      'button.back.to.applications': 'Retour à mes candidatures',
      'button.enter.job.description': 'Saisir la description du poste',
             'cv.personal.fullname': 'Nom complet',
       'cv.personal.company': 'Entreprise',
       'cv.personal.address': 'Adresse',
       'cv.personal.postal.code': 'Code postal',
       'cv.personal.city': 'Ville',
       'cv.personal.phone': 'Numéro de téléphone',
      'cv.personal.email': 'Adresse e-mail',
      'cv.personal.birthyear': 'Année de naissance',
             'cv.personal.nationality': 'Nationalité',
       'cv.personal.nationality.select': 'Veuillez sélectionner...',
       'cv.personal.nationality.swiss': 'Suisse',
       'cv.personal.nationality.german': 'Allemand(e)',
       'cv.personal.nationality.austrian': 'Autrichien(ne)',
       'cv.personal.nationality.french': 'Français(e)',
       'cv.personal.nationality.italian': 'Italien(ne)',
       'cv.personal.nationality.spanish': 'Espagnol(e)',
       'cv.personal.nationality.british': 'Britannique',
       'cv.personal.nationality.american': 'Américain(e)',
       'cv.personal.nationality.canadian': 'Canadien(ne)',
       'cv.personal.nationality.australian': 'Australien(ne)',
       'cv.personal.nationality.japanese': 'Japonais(e)',
       'cv.personal.nationality.chinese': 'Chinois(e)',
       'cv.personal.nationality.indian': 'Indien(ne)',
       'cv.personal.nationality.brazilian': 'Brésilien(ne)',
       'cv.personal.nationality.argentinian': 'Argentin(e)',
       'cv.personal.nationality.mexican': 'Mexicain(e)',
       'cv.personal.nationality.russian': 'Russe',
       'cv.personal.nationality.turkish': 'Turc(que)',
       'cv.personal.nationality.moroccan': 'Marocain(e)',
       'cv.personal.nationality.egyptian': 'Égyptien(ne)',
       'cv.personal.nationality.south-african': 'Sud-Africain(e)',
       'cv.personal.nationality.nigerian': 'Nigerian(e)',
       'cv.personal.nationality.kenyan': 'Kényan(e)',
       'cv.personal.nationality.other': 'Autre',
       'cv.personal.permit': 'Permis de séjour',
       'cv.personal.permit.select': 'Veuillez sélectionner...',
       'cv.personal.civilstatus': 'État civil',
       'cv.personal.civilstatus.select': 'Veuillez sélectionner...',
       'cv.personal.civilstatus.single': 'Célibataire',
       'cv.personal.civilstatus.married': 'Marié(e)',
       'cv.personal.civilstatus.divorced': 'Divorcé(e)',
       'cv.personal.civilstatus.widowed': 'Veuf/Veuve',
       'cv.personal.civilstatus.registered-partnership': 'Partenaire enregistré(e)',
       'cv.personal.profile.picture': 'Photo de profil',
       'cv.personal.profile.upload': 'Télécharger image',
       'cv.personal.profile.format': 'JPG, PNG (max. 2MB)',
      'cv.short.profile': 'Profil court',
      'cv.work.experience': 'Expérience professionnelle',
      'cv.education': 'Formation',
      'cv.certificates': 'Formation continue / Certificats',
      'cv.languages': 'Compétences linguistiques',
      'cv.languages.language': 'Langue',
      'cv.languages.level': 'Niveau',
      'cv.languages.level.select': 'Choisir le niveau',
      'cv.languages.level.A1': 'A1 - Débutant',
      'cv.languages.level.A2': 'A2 - Connaissances de base',
      'cv.languages.level.B1': 'B1 - Utilisation avancée',
      'cv.languages.level.B2': 'B2 - Utilisation indépendante',
      'cv.languages.level.C1': 'C1 - Compétences spécialisées',
      'cv.languages.level.C2': 'C2 - Quasi langue maternelle',
      'cv.languages.level.native': 'Langue maternelle',
      'cv.it.skills': 'Compétences informatiques',
      'cv.it.skills.skill': 'Compétence',
      'cv.it.skills.level': 'Niveau',
      'cv.it.skills.level.select': 'Choisir le niveau',
      'cv.it.skills.level.beginner': 'Débutant',
      'cv.it.skills.level.intermediate': 'Avancé',
      'cv.it.skills.level.professional': 'Professionnel',
      'cv.it.skills.level.expert': 'Expert',
      'cv.additional.info': 'Informations supplémentaires',
      'language.select': 'Sélectionner la langue',
      'login.title': 'Se connecter',
      'login.email': 'E-mail',
      'login.password': 'Mot de passe',
      'login.submit': 'Se connecter',
      'login.google': 'Se connecter avec Google',
      'login.tab.login': 'Se connecter',
      'login.tab.register': 'S\'inscrire',
      'login.password.confirm': 'Confirmer le mot de passe',
      'login.password.mismatch': 'Les mots de passe ne correspondent pas',
      'login.password.too.short': 'Le mot de passe doit comporter au moins 6 caractères',
      'login.password.requirements': 'Au moins 6 caractères requis',
      'login.password.strength': 'Force du mot de passe',
      'login.password.min.length': 'Au moins 6 caractères',
      'login.password.recommended': '8+ caractères (recommandé)',
      'login.registering': 'Inscription...',
      'login.logging.in': 'Connexion...',
      'login.google.logging.in': 'Connexion Google...',
      'login.register.button': 'S\'inscrire',
      'login.error.registration': 'Échec de l\'inscription',
      'login.error.login': 'Échec de la connexion',
      'login.error.google': 'Échec de la connexion Google',
      'login.error.invalid.email': 'Veuillez saisir une adresse e-mail valide.',
      'login.error.login.credentials': 'L\'e-mail ou le mot de passe est incorrect.',
      'login.error.register.email.in.use': 'Cette adresse e-mail est déjà utilisée. Veuillez vous connecter ou réinitialiser le mot de passe.',
      'login.error.register.weak.password': 'Le mot de passe est trop faible. Utilisez au moins 6 caractères.',
      'login.error.too.many.requests': 'Trop de tentatives. Veuillez patienter un instant et réessayer.',
      'login.error.network': 'Erreur réseau. Vérifiez votre connexion Internet et réessayez.',
      'login.error.google.popup.closed': 'Connexion Google annulée. La fenêtre a été fermée.',
      'login.error.google.popup.blocked': 'La fenêtre Google a été bloquée. Autorisez les popups pour ce site.',
      'login.error.google.popup.cancelled': 'Connexion Google annulée. Veuillez réessayer.',
      'login.error.google.unauthorized.domain': 'Ce domaine n\'est pas autorisé pour la connexion Google.',
      'login.error.google.invalid.continue.uri': 'La connexion Google est actuellement mal configurée (continue URI).',
      'login.error.operation.not.allowed': 'Cette méthode de connexion n\'est pas activée actuellement.',
      'login.verification.sent.title': 'Inscription réussie!',
      'login.verification.sent.message': 'Un e-mail de vérification a été envoyé à {{email}}. Veuillez vérifier votre boîte de réception et cliquer sur le lien de confirmation.',
      'login.verification.spam.warning': 'Important: Vérifiez également votre dossier SPAM!',
      'login.verification.after.message': 'Après la vérification, vous pouvez vous connecter avec vos identifiants.',
      'login.verification.resend.button': 'Renvoyer l\'e-mail',
      'login.verification.resending': 'Envoi...',
      'login.verification.resend.success': 'L\'e-mail de vérification a été renvoyé! Vérifiez également votre dossier spam.',
      'login.verification.resend.error': 'Erreur lors du renvoi de l\'e-mail. Veuillez vérifier votre mot de passe.',
      'login.verification.password.prompt': 'Veuillez entrer votre mot de passe pour renvoyer l\'e-mail:',
      'login.verification.required': 'Veuillez d\'abord vérifier votre adresse e-mail. Vérifiez votre boîte de réception.',
      'login.forgot.password': 'Mot de passe oublié ?',
      'login.reset.title': 'Réinitialiser le mot de passe',
      'login.reset.info': 'Saisis ton e‑mail. Si un compte existe, nous t\'enverrons des instructions.',
      'login.reset.sent': 'Si un compte existe, nous t\'avons envoyé un e‑mail.',
      'login.reset.submit': 'Envoyer l\'e‑mail',
      'login.reset.new.title': 'Définir un nouveau mot de passe',
      'login.reset.new.info': 'Saisis ton nouveau mot de passe.',
      'login.reset.new.password': 'Nouveau mot de passe',
      'login.reset.new.confirm': 'Confirmer le mot de passe',
      'login.reset.new.submit': 'Enregistrer le mot de passe',
      'login.reset.new.success': 'Ton mot de passe a été modifié avec succès. Tu peux maintenant te connecter.',
      'login.reset.new.error': 'Le lien est invalide ou expiré. Veuillez demander un nouveau lien.',
      'login.reset.new.mismatch': 'Les mots de passe ne correspondent pas.',
      'login.reset.new.too.short': 'Le mot de passe doit comporter au moins 6 caractères.',
      'login.reset.new.to.login': 'Vers la connexion',
      'common.cancel': 'Annuler',
      'logout': 'Se déconnecter',
      'account': 'Compte',
      'account.plan': 'Plan tarifaire',
      'account.type': 'Type de compte',
      'account.type.free': 'Free',
      'account.type.basic': 'Basic',
      'account.type.pro': 'Pro',
      'account.type.beta.testing': 'Beta-Testing',
      'account.unlimited.users': 'Utilisateurs illimités',
      'account.unlimited.cv.data.sets': 'Ensembles de données CV illimités',
      'account.save': 'Fermer',
      'account.saving': 'Enregistrement...',
      'account.save.success': 'Type de compte enregistré avec succès',
      'account.save.error': 'Erreur lors de l\'enregistrement du type de compte',
      'account.limit.users.reached': 'La limite d\'utilisateurs pour votre type de compte a été atteinte. Maximum {max} utilisateurs autorisés.',
      'account.limit.cvs.reached': 'La limite d\'ensembles de données CV pour votre type de compte a été atteinte. Maximum {max} ensembles de données CV autorisés.',
      'account.type.change.too.many.users': 'Vous ne pouvez pas passer à {planType} car vous avez actuellement {currentUsers} utilisateurs. Le plan {planType} autorise un maximum de {maxUsers} utilisateurs. Veuillez d\'abord supprimer {removeCount} utilisateur(s).',
      'account.type.change.too.many.cvs': 'Vous ne pouvez pas passer à {planType} car vous avez actuellement {currentCvs} ensembles de données CV. Le plan {planType} autorise un maximum de {maxCvs} ensembles de données CV. Veuillez d\'abord supprimer {removeCount} ensemble(s) de données CV.',
      'account.pdf.download.not.available.free': 'Le téléchargement PDF n\'est pas disponible dans le plan gratuit. Veuillez passer à Basic ou Pro.',
      'account.upgrade.title': 'Mettre à niveau le plan tarifaire',
      'account.upgrade.message': 'Les téléchargements PDF ne sont pas disponibles dans le plan gratuit',
      'account.upgrade.description': 'Veuillez passer à Basic ou Pro pour utiliser les téléchargements PDF.',
      'account.upgrade.limit.title': 'Limite PDF épuisée',
      'account.upgrade.limit.message': 'Votre limite PDF a été atteinte.',
      'account.upgrade.limit.description': 'Veuillez attendre la prochaine période de facturation ou passer à un plan supérieur.',
      'account.upgrade.button': 'Vers le compte',
      'account.pdf.downloads': 'Téléchargements PDF',
      'cv.current.dataset.tooltip': 'Ceci est l\'ensemble de données actuel',
      'cv.share.save.and.approve': 'Enregistrer et approuver',
      'cv.share.saving': 'Enregistrement...',
      'cv.share.saved': 'Données enregistrées',
      'account.pdf.downloads.not.included': 'Pas de téléchargements PDF',
      'account.pdf.downloads.included': 'Téléchargements PDF inclus',
      'account.subscription.until': 'Valable jusqu\'au',
      'account.subscription.cancels': 'Résiliation le',
      'account.subscription.cancelled': 'Résilié',
      'account.subscription.auto.renew': 'Se renouvelle automatiquement',
      'account.cv.data.sets': 'Ensembles de données CV',
      'account.users': 'Utilisateurs',
      'account.users.loading': 'Chargement des utilisateurs...',
      'account.users.none': 'Aucun utilisateur trouvé',
      'account.users.email': 'E-mail',
      'account.users.role': 'Rôle',
      'account.users.role.owner': 'Propriétaire',
      'account.users.role.member': 'Membre',
      'account.users.role.change.promote': 'Passer en propriétaire',
      'account.users.role.change.demote': 'Retirer le statut de propriétaire',
      'account.users.role.change.confirm.promote': 'Voulez-vous passer cet utilisateur en propriétaire ?',
      'account.users.role.change.confirm.demote': 'Voulez-vous retirer le statut de propriétaire de cet utilisateur ?',
      'account.users.role.change.success.promote': 'L\'utilisateur est maintenant propriétaire',
      'account.users.role.change.success.demote': 'Le statut de propriétaire a été retiré',
      'account.users.role.change.error': 'Erreur lors du changement de rôle',
      'account.users.role.change.last.owner.error': 'Le dernier propriétaire ne peut pas être rétrogradé',
      'application.responsible.person': 'Personne responsable',
      'account.invite': 'Inviter un utilisateur',
      'account.invite.email': 'Adresse e-mail',
      'account.name': 'Nom du compte',
      'account.name.placeholder': 'p.ex. Mon entreprise',
      'account.invite.email.placeholder': 'email@exemple.com',
      'account.invite.send': 'Envoyer l\'invitation',
      'account.invite.sending': 'Envoi de l\'invitation...',
      'account.invite.success': 'Invitation envoyée',
      'account.invite.error': 'Erreur lors de l\'envoi de l\'invitation',
      'account.invite.invalid.email': 'Adresse e-mail invalide',
      'account.invite.email.not.sent': 'L\'e-mail n\'a pas pu être envoyé automatiquement. Veuillez copier le lien et l\'envoyer manuellement:',
      'account.invite.link': 'Lien d\'invitation',
      'account.invite.copy': 'Copier',
      'account.invite.link.copied': 'Le lien a été copié dans le presse-papiers',
      'account.invite.open.email': 'Ouvrir l\'e-mail',
      'account.invite.email.subject': 'Invitation au compte Curiculum',
      'account.invite.email.body': 'Vous avez été invité à rejoindre un compte Curiculum.\n\nCliquez sur le lien suivant pour vous inscrire et rejoindre le compte:\n{link}\n\nCe lien est valable 7 jours.',
      'account.invite.link.not.available': 'Erreur: Le lien d\'invitation n\'a pas pu être créé. Veuillez réessayer.',
      'account.users.delete': 'Supprimer',
      'account.users.delete.confirm': 'Voulez-vous vraiment supprimer cet utilisateur?',
      'account.users.delete.success': 'Utilisateur supprimé avec succès',
      'account.users.delete.error': 'Erreur lors de la suppression de l\'utilisateur',
      'account.users.delete.deleting': 'Suppression de l\'utilisateur...',
      'invite.title': 'Invitation au compte',
      'invite.message': 'Vous avez été invité à rejoindre {{accountName}}. Veuillez vous inscrire pour rejoindre le compte.',
      'invite.loading': 'Chargement des données d\'invitation...',
      'invite.invalid': 'Lien d\'invitation invalide ou expiré',
      'invite.error.loading': 'Erreur lors du chargement des données d\'invitation',
      'invite.error.register': 'Erreur lors de l\'inscription',
      'invite.error.accept': 'Erreur lors de l\'acceptation de l\'invitation',
      'invite.error.google': 'Erreur lors de l\'inscription Google',
      'invite.error.email.mismatch': 'L\'adresse e-mail Google ne correspond pas à l\'e-mail d\'invitation',
      'invite.success': 'Inscription réussie! Vous allez être redirigé...',
      'invite.redirecting': 'Redirection...',
      'invite.register': 'S\'inscrire',
      'invite.registering': 'Inscription...',
      'invite.tab.email': 'E-mail et mot de passe',
      'invite.tab.google': 'Avec Google',
      'invite.email.info': 'Veuillez utiliser l\'adresse e-mail {{email}} pour l\'inscription.',
      'invite.logged.in': 'Vous êtes déjà connecté en tant que {{email}}.',
      'invite.accept': 'Accepter l\'invitation',
      'invite.accepting': 'Acceptation...',
       'clear.all.data': 'Effacer toutes les données',
       'Daten speichern': 'Enregistrer les données',
       'Keine Änderungen zum Speichern': 'Aucune modification à enregistrer',
       'cv.work.experience.add': 'Ajouter expérience professionnelle',
       'cv.work.experience.period': 'Période',
       'cv.work.experience.company': 'Entreprise',
       'cv.work.experience.position': 'Poste',
       'cv.education.add': 'Ajouter formation',
       'cv.education.institution': 'Institution',
       'cv.education.degree': 'Diplôme',
       'cv.certification.add': 'Ajouter certification / formation continue',
       'cv.certification.name': 'Nom',
       'cv.certification.issuer': 'Émetteur',
       'cv.certification.date': 'Date',
       'cv.certification.description': 'Description',
       'cv.certification.title': 'Certification / Formation continue',
       'cv.certification.extracted': 'Certifications extraites',
       'button.cancel': 'Annuler',
       'button.add': 'Ajouter',
       'button.delete': 'Supprimer',
       'label.start': 'Début',
       'label.end': 'Fin',
       'extraction.uploading': 'Téléchargement du fichier...',
       'extraction.processing': 'Traitement du CV...',
       'extraction.short.profile': 'Extraction du profil court...',
       'extraction.work.experience': 'Extraction de l\'expérience professionnelle...',
       'extraction.education': 'Extraction de la formation...',
       'extraction.certifications': 'Extraction des certifications...',
       'extraction.personal.info': 'Extraction des données personnelles...',
       'extraction.fallback': 'Utilisation de l\'extraction locale...',
       'extraction.complete': 'Extraction terminée!',
       'error.clear.data': 'Errore durante la cancellazione dei dati: ',
       'ai.extraction.title': 'Estrazione assistita da IA',
       'ai.extraction.description': 'I dati personali vengono estratti automaticamente con l\'IA',
       "cv.education.title": "Formation",
       "cv.education.startDate": "Date de début",
       "cv.education.endDate": "Date de fin",
       'agb.title': 'Conditions générales',
       'agb.welcome': 'Bienvenue! Veuillez lire et accepter nos conditions générales pour utiliser l\'application.',
       'agb.readInstructions': 'Veuillez lire attentivement les CGU:',
       'agb.link': 'Ouvrir les CGU (nouvel onglet)',
       'agb.confirmation': 'J\'ai lu et j\'accepte les CGU.',
       'agb.confirmation.before': 'J\'ai lu les',
       'agb.confirmation.link': 'CGU',
       'agb.confirmation.after': 'et je les accepte.',
       'agb.notice': 'Remarque: Vous devez accepter les CGU pour utiliser l\'application. Vous pouvez vous déconnecter à tout moment.',
       'agb.logout': 'Se déconnecter',
       'agb.accept': 'Accepter les CGU',
       'footer.copyright': '© {{year}} acceler-8. Tous droits réservés.',
       'footer.impressum': 'Mentions légales',
       'footer.privacy': 'Protection des données',
       'footer.terms': 'CGU',
       'impressum.title': 'Mentions légales',
       'impressum.email': 'E-mail',
       'impressum.registry': 'N° du registre du commerce',
       'impressum.country': 'Suisse',
       'impressum.back': 'Retour à l’accueil',
      'agb.accepting': 'Acceptation...',
      'agb.error.loading': 'Erreur lors du chargement du statut CGU',
      'agb.error.retry': 'Veuillez réessayer ou contacter le support.',
      'agb.error.reload': 'Recharger la page',
      'cv.import.warning.title': 'Avis important sur la qualité des données',
      'cv.import.warning.message': 'Vérifie attentivement les données extraites !',
      'cv.import.warning.description': 'L\'extraction de données CV basée sur l\'IA n\'atteint pas une précision de 100%. Des erreurs peuvent survenir lors de la reconnaissance de :',
      'cv.import.warning.item1': 'Noms, adresses et données de contact',
      'cv.import.warning.item2': 'Expériences professionnelles et périodes',
      'cv.import.warning.item3': 'Formations et certifications',
      'cv.import.warning.item4': 'Compétences et capacités',
      'cv.import.warning.footer': 'Corrige toutes les erreurs détectées avant de continuer avec la candidature.',
      'cv.import.warning.button': 'Fermer',
      'cv.import.warning.dontShowAgain': 'Ne plus afficher cette information.',
      'cv.template.warning.title': 'Note importante sur le modèle CV',
      'cv.template.warning.message': 'Veuillez lire attentivement le projet de CV et l\'adapter !',
      'cv.template.warning.description': 'L\'IA ne crée qu\'un premier projet. Tu dois faire la finition et vérifier les domaines suivants :',
      'cv.template.warning.item1': 'Formatage et mise en page',
      'cv.template.warning.item2': 'Exactitude des informations',
      'cv.template.warning.item3': 'Pertinence pour l\'offre d\'emploi',
      'cv.template.warning.disclaimer': 'Les contenus générés par l\'IA sont des brouillons et doivent être vérifiés par un professionnel avant utilisation. Aucune garantie n\'est donnée quant à l\'exhaustivité, l\'exactitude ou le succès.',
      'cv.template.warning.footer': 'Prends le temps d\'une révision soigneuse avant d\'utiliser le CV.',
      'cv.template.warning.button': 'Fermer',
      'cv.template.warning.dontShowAgain': 'Ne plus afficher cette information.',
      'cv.motivation.warning.title': 'Note importante sur la lettre de motivation',
      'cv.motivation.warning.message': 'Veuillez lire attentivement la lettre de motivation et l\'adapter !',
      'cv.motivation.warning.description': 'L\'IA ne crée qu\'un premier projet. Tu dois faire la finition et vérifier les domaines suivants :',
      'cv.motivation.warning.item1': 'Orthographe et grammaire',
      'cv.motivation.warning.item2': 'Adresse personnelle et ton',
      'cv.motivation.warning.item3': 'Pertinence pour l\'offre d\'emploi',
      'cv.motivation.warning.item4': 'Exhaustivité des arguments',
      'cv.motivation.warning.footer': 'Prends le temps d\'une révision soigneuse avant d\'utiliser la lettre de motivation.',
      'cv.motivation.warning.button': 'Fermer',
      'cv.motivation.warning.dontShowAgain': 'Ne plus afficher cette information.',
      'onboarding.title': 'Bienvenue! Complète ton profil',
      'onboarding.firstName': 'Prénom',
      'onboarding.lastName': 'Nom',
      'onboarding.gender': 'Sexe',
      'onboarding.gender.male': 'Masculin',
      'onboarding.gender.female': 'Féminin',
      'onboarding.gender.diverse': 'Divers',
      'onboarding.gender.unspecified': 'Non spécifié',
      'onboarding.country': 'Pays',
      'onboarding.country.ch': 'CH - Suisse',
      'onboarding.country.de': 'DE - Allemagne',
      'onboarding.country.at': 'AT - Autriche',
      'onboarding.country.fr': 'FR - France',
      'onboarding.country.it': 'IT - Italie',
      'onboarding.company': 'Entreprise (Optionnel)',
      'onboarding.save': 'Enregistrer',
      'onboarding.saving': 'Enregistrement...',
      'cv.image.upload.title.header': 'Sélectionner le graphique d\'en-tête',
      'cv.image.upload.title.column': 'Sélectionner le graphique de colonne',
      'cv.image.upload.maxSize': 'Taille maximale du graphique:',
      'cv.image.upload.maxSize.header': 'Graphique d\'en-tête: Maximum 794 pixels (largeur) x 228 pixels (hauteur)',
      'cv.image.upload.maxSize.column': 'Graphique de colonne: Maximum 318 pixels (largeur) x 1123 pixels (hauteur)',
      'cv.image.upload.info': 'Veuillez sélectionner un graphique qui ne dépasse pas ces dimensions.',
      'cv.image.upload.alignment': 'Le graphique sera aligné à gauche et en haut.',
      'cv.image.upload.select': 'Sélectionner le graphique',
      'cv.image.upload.error.tooLarge': 'Image trop grande! Taille maximale: {{maxWidth}}x{{maxHeight}} pixels. Votre image: {{width}}x{{height}} pixels',
      'Passgenauigkeit akzeptieren': 'Accepter le score de correspondance',
      'CV-Vorschau öffnen': 'Ouvrir l\'aperçu CV',
      'Erstellungsdatum': 'Date de création',
    }
  },
  it: {
    translation: {
      'app.title': 'Ottimizzatore CV',
      'app.description': 'Carica il tuo CV e ottieni una versione ottimizzata basata sulla descrizione del lavoro.',
      'upload.cv': 'Carica CV',
      'upload.job': 'Carica descrizione lavoro',
      'upload.job.description': 'Carica una descrizione del lavoro o inseriscila manualmente',
      'job.description': 'Descrizione del lavoro',
      'job.description.placeholder': 'Descrivi il lavoro per cui ti stai candidando...',
      'analyze': 'Analizza',
      'download.original': 'Scarica CV originale',
      'download.improved': 'Scarica CV migliorato',
      'download.motivation': 'Scarica lettera di motivazione',
      'match.score': 'Punteggio di corrispondenza',
      'missing.skills': 'Competenze mancanti',
      'improved.cv': 'CV migliorato',
      'motivation.letter': 'Lettera di motivazione',
      'loading': 'Caricamento...',
      'error.upload': 'Errore durante il caricamento',
      'error.analyze': 'Errore durante l\'analisi',
      'error.download': 'Errore durante il download',
      'error.backend.api': 'URL API backend non configurata',
      'error.extract.cv': 'Errore durante l\'estrazione del testo del CV',
      'error.extract.cv.unknown': 'Errore sconosciuto durante l\'estrazione del testo del CV: ',
      'cv.original.text': 'Testo CV originale',
      'cv.personal.info': 'Informazioni personali',
      'cv.tab.data': 'Dati CV',
      'cv.tab.start': 'Candidature',
      'cv.tab.job.description': 'Descrizione del lavoro',
      'cv.tab.optimization': 'Ottimizzazione',
      'cv.subtab.applications': 'Candidature',
      'cv.subtab.job.description': 'Descrizione del lavoro',
      'cv.subtab.optimization': 'Ottimizzazione',
      'button.next': 'Avanti',
      'button.back.to.applications': 'Torna alle mie candidature',
      'button.enter.job.description': 'Inserisci descrizione del lavoro',
             'cv.personal.fullname': 'Nome completo',
       'cv.personal.company': 'Azienda',
       'cv.personal.address': 'Indirizzo',
       'cv.personal.postal.code': 'Codice postale',
       'cv.personal.city': 'Città',
       'cv.personal.phone': 'Numero di telefono',
      'cv.personal.email': 'Indirizzo e-mail',
      'cv.personal.birthyear': 'Anno di nascita',
             'cv.personal.nationality': 'Nazionalità',
       'cv.personal.nationality.select': 'Seleziona...',
       'cv.personal.nationality.swiss': 'Svizzero/a',
       'cv.personal.nationality.german': 'Tedesco/a',
       'cv.personal.nationality.austrian': 'Austriaco/a',
       'cv.personal.nationality.french': 'Francese',
       'cv.personal.nationality.italian': 'Italiano/a',
       'cv.personal.nationality.spanish': 'Spagnolo/a',
       'cv.personal.nationality.british': 'Britannico/a',
       'cv.personal.nationality.american': 'Americano/a',
       'cv.personal.nationality.canadian': 'Canadese',
       'cv.personal.nationality.australian': 'Australiano/a',
       'cv.personal.nationality.japanese': 'Giapponese',
       'cv.personal.nationality.chinese': 'Cinese',
       'cv.personal.nationality.indian': 'Indiano/a',
       'cv.personal.nationality.brazilian': 'Brasiliano/a',
       'cv.personal.nationality.argentinian': 'Argentino/a',
       'cv.personal.nationality.mexican': 'Messicano/a',
       'cv.personal.nationality.russian': 'Russo/a',
       'cv.personal.nationality.turkish': 'Turco/a',
       'cv.personal.nationality.moroccan': 'Marocchino/a',
       'cv.personal.nationality.egyptian': 'Egiziano/a',
       'cv.personal.nationality.south-african': 'Sudafricano/a',
       'cv.personal.nationality.nigerian': 'Nigeriano/a',
       'cv.personal.nationality.kenyan': 'Kenyano/a',
       'cv.personal.nationality.other': 'Altro/a',
       'cv.personal.permit': 'Permesso di soggiorno',
       'cv.personal.permit.select': 'Seleziona...',
       'cv.personal.civilstatus': 'Stato civile',
       'cv.personal.civilstatus.select': 'Seleziona...',
       'cv.personal.civilstatus.single': 'Celibe/Nubile',
       'cv.personal.civilstatus.married': 'Sposato/a',
       'cv.personal.civilstatus.divorced': 'Divorziato/a',
       'cv.personal.civilstatus.widowed': 'Vedovo/a',
       'cv.personal.civilstatus.registered-partnership': 'Unione civile',
       'cv.personal.profile.picture': 'Foto profilo',
       'cv.personal.profile.upload': 'Carica immagine',
       'cv.personal.profile.format': 'JPG, PNG (max. 2MB)',
      'cv.short.profile': 'Profilo breve',
      'cv.work.experience': 'Esperienza lavorativa',
      'cv.education': 'Formazione',
      'cv.certificates': 'Formazione continua / Certificati',
      'cv.languages': 'Competenze linguistiche',
      'cv.languages.language': 'Lingua',
      'cv.languages.level': 'Livello',
      'cv.languages.level.select': 'Scegliere il livello',
      'cv.languages.level.A1': 'A1 - Principiante',
      'cv.languages.level.A2': 'A2 - Conoscenze di base',
      'cv.languages.level.B1': 'B1 - Uso avanzato della lingua',
      'cv.languages.level.B2': 'B2 - Uso indipendente della lingua',
      'cv.languages.level.C1': 'C1 - Competenze linguistiche specialistiche',
      'cv.languages.level.C2': 'C2 - Quasi madrelingua',
      'cv.languages.level.native': 'Madrelingua',
      'cv.it.skills': 'Competenze informatiche',
      'cv.it.skills.skill': 'Competenza',
      'cv.it.skills.level': 'Livello',
      'cv.it.skills.level.select': 'Scegliere il livello',
      'cv.it.skills.level.beginner': 'Principiante',
      'cv.it.skills.level.intermediate': 'Avanzato',
      'cv.it.skills.level.professional': 'Professionista',
      'cv.it.skills.level.expert': 'Esperto',
      'cv.additional.info': 'Informazioni aggiuntive',
      'language.select': 'Seleziona lingua',
      'login.title': 'Accedi',
      'login.email': 'E-mail',
      'login.password': 'Password',
      'login.submit': 'Accedi',
      'login.google': 'Accedi con Google',
      'login.tab.login': 'Accedi',
      'login.tab.register': 'Registrati',
      'login.password.confirm': 'Conferma password',
      'login.password.mismatch': 'Le password non corrispondono',
      'login.password.too.short': 'La password deve essere di almeno 6 caratteri',
      'login.password.requirements': 'Almeno 6 caratteri richiesti',
      'login.password.strength': 'Forza della password',
      'login.password.min.length': 'Almeno 6 caratteri',
      'login.password.recommended': '8+ caratteri (consigliato)',
      'login.registering': 'Registrazione...',
      'login.logging.in': 'Accesso...',
      'login.google.logging.in': 'Accesso Google...',
      'login.register.button': 'Registrati',
      'login.error.registration': 'Registrazione fallita',
      'login.error.login': 'Accesso fallito',
      'login.error.google': 'Accesso Google fallito',
      'login.error.invalid.email': 'Inserisci un indirizzo e-mail valido.',
      'login.error.login.credentials': 'E-mail o password non corretti.',
      'login.error.register.email.in.use': 'Questo indirizzo e-mail è già in uso. Accedi oppure usa il recupero password.',
      'login.error.register.weak.password': 'La password è troppo debole. Usa almeno 6 caratteri.',
      'login.error.too.many.requests': 'Troppi tentativi. Attendi un momento e riprova.',
      'login.error.network': 'Errore di rete. Controlla la connessione Internet e riprova.',
      'login.error.google.popup.closed': 'Accesso Google annullato. La finestra è stata chiusa.',
      'login.error.google.popup.blocked': 'Il popup Google è stato bloccato. Consenti i popup per questo sito.',
      'login.error.google.popup.cancelled': 'Accesso Google annullato. Riprova.',
      'login.error.google.unauthorized.domain': 'Questo dominio non è autorizzato per l\'accesso Google.',
      'login.error.google.invalid.continue.uri': 'L\'accesso Google non è configurato correttamente (continue URI).',
      'login.error.operation.not.allowed': 'Questo metodo di accesso non è attualmente attivato.',
      'login.verification.sent.title': 'Registrazione riuscita!',
      'login.verification.sent.message': 'Un\'e-mail di verifica è stata inviata a {{email}}. Controlla la tua casella di posta e clicca sul link di conferma.',
      'login.verification.spam.warning': 'Importante: Controlla anche la cartella SPAM!',
      'login.verification.after.message': 'Dopo la verifica, puoi accedere con le tue credenziali.',
      'login.verification.resend.button': 'Invia di nuovo l\'e-mail',
      'login.verification.resending': 'Invio...',
      'login.verification.resend.success': 'L\'e-mail di verifica è stata inviata di nuovo! Controlla anche la cartella spam.',
      'login.verification.resend.error': 'Errore durante l\'invio dell\'e-mail. Controlla la tua password.',
      'login.verification.password.prompt': 'Inserisci la tua password per inviare di nuovo l\'e-mail:',
      'login.verification.required': 'Verifica prima il tuo indirizzo e-mail. Controlla la tua casella di posta.',
      'login.forgot.password': 'Password dimenticata?',
      'login.reset.title': 'Reimposta password',
      'login.reset.info': 'Inserisci la tua e‑mail. Se esiste un account, ti invieremo le istruzioni.',
      'login.reset.sent': 'Se esiste un account, ti abbiamo inviato un\'e‑mail.',
      'login.reset.submit': 'Invia e‑mail',
      'login.reset.new.title': 'Imposta una nuova password',
      'login.reset.new.info': 'Inserisci la tua nuova password.',
      'login.reset.new.password': 'Nuova password',
      'login.reset.new.confirm': 'Conferma password',
      'login.reset.new.submit': 'Salva password',
      'login.reset.new.success': 'La tua password è stata modificata con successo. Ora puoi accedere.',
      'login.reset.new.error': 'Il link non è valido o è scaduto. Richiedi un nuovo link.',
      'login.reset.new.mismatch': 'Le password non corrispondono.',
      'login.reset.new.too.short': 'La password deve contenere almeno 6 caratteri.',
      'login.reset.new.to.login': 'Vai al login',
      'common.cancel': 'Annulla',
      'logout': 'Disconnetti',
      'account': 'Account',
      'account.plan': 'Piano tariffario',
      'account.type': 'Tipo di account',
      'account.type.free': 'Free',
      'account.type.basic': 'Basic',
      'account.type.pro': 'Pro',
      'account.type.beta.testing': 'Beta-Testing',
      'account.unlimited.users': 'Utenti illimitati',
      'account.unlimited.cv.data.sets': 'Set di dati CV illimitati',
      'account.save': 'Chiudi',
      'account.saving': 'Salvataggio...',
      'account.save.success': 'Tipo di account salvato con successo',
      'account.save.error': 'Errore nel salvataggio del tipo di account',
      'account.limit.users.reached': 'Il limite utenti per il tuo tipo di account è stato raggiunto. Massimo {max} utenti consentiti.',
      'account.limit.cvs.reached': 'Il limite di set di dati CV per il tuo tipo di account è stato raggiunto. Massimo {max} set di dati CV consentiti.',
      'account.type.change.too.many.users': 'Non puoi passare a {planType} perché hai attualmente {currentUsers} utenti. Il piano {planType} consente un massimo di {maxUsers} utenti. Rimuovi prima {removeCount} utente/i.',
      'account.type.change.too.many.cvs': 'Non puoi passare a {planType} perché hai attualmente {currentCvs} set di dati CV. Il piano {planType} consente un massimo di {maxCvs} set di dati CV. Rimuovi prima {removeCount} set di dati CV.',
      'account.pdf.download.not.available.free': 'Il download PDF non è disponibile nel piano gratuito. Si prega di passare a Basic o Pro.',
      'account.upgrade.title': 'Aggiorna piano tariffario',
      'account.upgrade.message': 'I download PDF non sono disponibili nel piano gratuito',
      'account.upgrade.description': 'Si prega di passare a Basic o Pro per utilizzare i download PDF.',
      'account.upgrade.limit.title': 'Limite PDF esaurito',
      'account.upgrade.limit.message': 'Hai raggiunto il tuo limite PDF.',
      'account.upgrade.limit.description': 'Attendi il prossimo periodo di fatturazione o passa a un piano superiore.',
      'account.upgrade.button': 'Al conto',
      'account.pdf.downloads': 'Download PDF',
      'cv.current.dataset.tooltip': 'Questo è il set di dati corrente',
      'cv.share.save.and.approve': 'Salva e approva',
      'cv.share.saving': 'Salvataggio...',
      'cv.share.saved': 'Dati salvati',
      'account.pdf.downloads.not.included': 'Nessun download PDF',
      'account.pdf.downloads.included': 'Download PDF inclusi',
      'account.subscription.until': 'Valido fino al',
      'account.subscription.cancels': 'Annullamento il',
      'account.subscription.cancelled': 'Annullato',
      'account.subscription.auto.renew': 'Si rinnova automaticamente',
      'account.cv.data.sets': 'Set di dati CV',
      'account.users': 'Utenti',
      'account.users.loading': 'Caricamento utenti...',
      'account.users.none': 'Nessun utente trovato',
      'account.users.email': 'E-mail',
      'account.users.role': 'Ruolo',
      'account.users.role.owner': 'Proprietario',
      'account.users.role.member': 'Membro',
      'account.users.role.change.promote': 'Rendi proprietario',
      'account.users.role.change.demote': 'Rimuovi stato proprietario',
      'account.users.role.change.confirm.promote': 'Vuoi rendere proprietario questo utente?',
      'account.users.role.change.confirm.demote': 'Vuoi rimuovere lo stato di proprietario da questo utente?',
      'account.users.role.change.success.promote': 'Utente promosso a proprietario',
      'account.users.role.change.success.demote': 'Stato proprietario rimosso',
      'account.users.role.change.error': 'Errore durante la modifica del ruolo utente',
      'account.users.role.change.last.owner.error': 'L\'ultimo proprietario non può essere retrocesso',
      'application.responsible.person': 'Persona responsabile',
      'account.invite': 'Invita utente',
      'account.invite.email': 'Indirizzo e-mail',
      'account.name': 'Nome dell\'account',
      'account.name.placeholder': 'es. La mia azienda',
      'account.invite.email.placeholder': 'email@esempio.com',
      'account.invite.send': 'Invia invito',
      'account.invite.sending': 'Invio invito...',
      'account.invite.success': 'Invito inviato',
      'account.invite.error': 'Errore nell\'invio dell\'invito',
      'account.invite.invalid.email': 'Indirizzo e-mail non valido',
      'account.invite.email.not.sent': 'L\'e-mail non può essere inviata automaticamente. Si prega di copiare il link e inviarlo manualmente:',
      'account.invite.link': 'Link di invito',
      'account.invite.copy': 'Copia',
      'account.invite.link.copied': 'Il link è stato copiato negli appunti',
      'account.invite.open.email': 'Apri e-mail',
      'account.invite.email.subject': 'Invito all\'account Curiculum',
      'account.invite.email.body': 'Sei stato invitato a unirti a un account Curiculum.\n\nClicca sul seguente link per registrarti e unirti all\'account:\n{link}\n\nQuesto link è valido per 7 giorni.',
      'account.invite.link.not.available': 'Errore: Il link di invito non può essere creato. Riprova.',
      'account.users.delete': 'Elimina',
      'account.users.delete.confirm': 'Vuoi davvero rimuovere questo utente?',
      'account.users.delete.success': 'Utente rimosso con successo',
      'account.users.delete.error': 'Errore durante la rimozione dell\'utente',
      'account.users.delete.deleting': 'Rimozione dell\'utente...',
      'invite.title': 'Invito all\'account',
      'invite.message': 'Sei stato invitato a {{accountName}}. Registrati per unirti all\'account.',
      'invite.loading': 'Caricamento dati invito...',
      'invite.invalid': 'Link di invito non valido o scaduto',
      'invite.error.loading': 'Errore nel caricamento dei dati di invito',
      'invite.error.register': 'Errore durante la registrazione',
      'invite.error.accept': 'Errore nell\'accettazione dell\'invito',
      'invite.error.google': 'Errore durante la registrazione Google',
      'invite.error.email.mismatch': 'L\'indirizzo e-mail di Google non corrisponde all\'e-mail di invito',
      'invite.success': 'Registrazione riuscita! Verrai reindirizzato...',
      'invite.redirecting': 'Reindirizzamento...',
      'invite.register': 'Registrati',
      'invite.registering': 'Registrazione...',
      'invite.tab.email': 'E-mail e password',
      'invite.tab.google': 'Con Google',
      'invite.email.info': 'Si prega di utilizzare l\'indirizzo e-mail {{email}} per la registrazione.',
      'invite.logged.in': 'Sei già connesso come {{email}}.',
      'invite.accept': 'Accetta invito',
      'invite.accepting': 'Accettazione...',
       'clear.all.data': 'Cancella tutti i dati',
       'Daten speichern': 'Salva dati',
       'Keine Änderungen zum Speichern': 'Nessuna modifica da salvare',
       'cv.work.experience.add': 'Aggiungi esperienza lavorativa',
       'cv.work.experience.period': 'Periodo',
       'cv.work.experience.company': 'Azienda',
       'cv.work.experience.position': 'Posizione',
       'cv.education.add': 'Aggiungi formazione',
       'cv.education.institution': 'Istituzione',
       'cv.education.degree': 'Laurea',
       'cv.certification.add': 'Aggiungi certificazione / formazione continua',
       'cv.certification.name': 'Nome',
       'cv.certification.issuer': 'Emittente',
       'cv.certification.date': 'Data',
       'cv.certification.description': 'Descrizione',
       'cv.certification.title': 'Certificazione / Formazione continua',
       'cv.certification.extracted': 'Certificazioni estratte',
       'button.cancel': 'Annulla',
       'button.add': 'Aggiungi',
       'button.delete': 'Elimina',
       'label.start': 'Inizio',
       'label.end': 'Fine',
       'extraction.uploading': 'Caricamento del file...',
       'extraction.processing': 'Elaborazione del CV...',
       'extraction.short.profile': 'Estrazione del profilo breve...',
       'extraction.work.experience': 'Estrazione dell\'esperienza lavorativa...',
       'extraction.education': 'Estrazione della formazione...',
       'extraction.certifications': 'Estrazione delle certificazioni...',
       'extraction.personal.info': 'Estrazione dei dati personali...',
       'extraction.fallback': 'Utilizzo dell\'estrazione locale...',
       'extraction.complete': 'Estrazione completata!',
       'error.clear.data': 'Errore durante la cancellazione dei dati: ',
       'ai.extraction.title': 'Estrazione assistita da IA',
       'ai.extraction.description': 'I dati personali vengono estratti automaticamente con l\'IA',
       "cv.education.title": "Formazione",
       "cv.education.startDate": "Data di inizio",
       "cv.education.endDate": "Data di fine",
       'agb.title': 'Termini e condizioni',
       'agb.welcome': 'Benvenuto! Si prega di leggere e accettare i nostri termini e condizioni per utilizzare l\'applicazione.',
       'agb.readInstructions': 'Si prega di leggere attentamente i termini e condizioni:',
       'agb.link': 'Aprire i termini e condizioni (nuova scheda)',
       'agb.confirmation': 'Ho letto e accetto i termini e condizioni.',
       'agb.confirmation.before': 'Ho letto i',
       'agb.confirmation.link': 'termini e condizioni',
       'agb.confirmation.after': 'e li accetto.',
       'agb.notice': 'Nota: È necessario accettare i termini e condizioni per utilizzare l\'applicazione. È possibile disconnettersi in qualsiasi momento.',
       'agb.logout': 'Disconnetti',
       'agb.accept': 'Accettare i termini e condizioni',
       'footer.copyright': '© {{year}} acceler-8. Tutti i diritti riservati.',
       'footer.impressum': 'Note legali',
       'footer.privacy': 'Privacy',
       'footer.terms': 'Termini',
       'impressum.title': 'Note legali',
       'impressum.email': 'E-mail',
       'impressum.registry': 'N. registro di commercio',
       'impressum.country': 'Svizzera',
       'impressum.back': 'Torna alla home',
      'agb.accepting': 'Accettazione...',
      'agb.error.loading': 'Errore durante il caricamento dello stato dei termini e condizioni',
      'agb.error.retry': 'Si prega di riprovare o contattare il supporto.',
      'agb.error.reload': 'Ricaricare la pagina',
      'cv.import.warning.title': 'Avviso importante sulla qualità dei dati',
      'cv.import.warning.message': 'Verifica attentamente i dati estratti!',
      'cv.import.warning.description': 'L\'estrazione di dati CV basata su IA non raggiunge una precisione del 100%. Possono verificarsi errori nel riconoscimento di:',
      'cv.import.warning.item1': 'Nomi, indirizzi e dati di contatto',
      'cv.import.warning.item2': 'Esperienze lavorative e periodi',
      'cv.import.warning.item3': 'Formazioni e certificazioni',
      'cv.import.warning.item4': 'Competenze e abilità',
      'cv.import.warning.footer': 'Correggi tutti gli errori rilevati prima di procedere con la candidatura.',
      'cv.import.warning.button': 'Chiudi',
      'cv.import.warning.dontShowAgain': 'Non mostrare più questa informazione.',
      'cv.template.warning.title': 'Nota importante sul modello CV',
      'cv.template.warning.message': 'Leggi attentamente la bozza del CV e adattala!',
      'cv.template.warning.description': 'L\'IA crea solo una prima bozza. Devi fare la rifinitura e verificare le seguenti aree:',
      'cv.template.warning.item1': 'Formattazione e layout',
      'cv.template.warning.item2': 'Correttezza delle informazioni',
      'cv.template.warning.item3': 'Rilevanza per l\'annuncio di lavoro',
      'cv.template.warning.disclaimer': 'I contenuti generati dall\'IA sono bozze e devono essere verificati professionalmente prima dell\'uso. Non si fornisce alcuna garanzia di completezza, correttezza o successo.',
      'cv.template.warning.footer': 'Prenditi il tempo per una revisione accurata prima di utilizzare il CV.',
      'cv.template.warning.button': 'Chiudi',
      'cv.template.warning.dontShowAgain': 'Non mostrare più questa informazione.',
      'cv.motivation.warning.title': 'Nota importante sulla lettera di motivazione',
      'cv.motivation.warning.message': 'Per favore leggi attentamente la lettera di motivazione e adattala!',
      'cv.motivation.warning.description': 'L\'IA crea solo una prima bozza. Devi fare la rifinitura e controllare le seguenti aree:',
      'cv.motivation.warning.item1': 'Ortografia e grammatica',
      'cv.motivation.warning.item2': 'Indirizzo personale e tono',
      'cv.motivation.warning.item3': 'Rilevanza per l\'annuncio di lavoro',
      'cv.motivation.warning.item4': 'Completezza degli argomenti',
      'cv.motivation.warning.footer': 'Prenditi il tempo per una revisione accurata prima di utilizzare la lettera di motivazione.',
      'cv.motivation.warning.button': 'Chiudi',
      'cv.motivation.warning.dontShowAgain': 'Non mostrare più questa informazione.',
      'onboarding.title': 'Benvenuto! Completa il tuo profilo',
      'onboarding.firstName': 'Nome',
      'onboarding.lastName': 'Cognome',
      'onboarding.gender': 'Genere',
      'onboarding.gender.male': 'Maschile',
      'onboarding.gender.female': 'Femminile',
      'onboarding.gender.diverse': 'Diverso',
      'onboarding.gender.unspecified': 'Non specificato',
      'onboarding.country': 'Paese',
      'onboarding.country.ch': 'CH - Svizzera',
      'onboarding.country.de': 'DE - Germania',
      'onboarding.country.at': 'AT - Austria',
      'onboarding.country.fr': 'FR - Francia',
      'onboarding.country.it': 'IT - Italia',
      'onboarding.company': 'Azienda (Opzionale)',
      'onboarding.save': 'Salva',
      'onboarding.saving': 'Salvataggio...',
      'cv.image.upload.title.header': 'Seleziona grafica intestazione',
      'cv.image.upload.title.column': 'Seleziona grafica colonna',
      'cv.image.upload.maxSize': 'Dimensione massima grafica:',
      'cv.image.upload.maxSize.header': 'Grafica intestazione: Massimo 794 pixel (larghezza) x 228 pixel (altezza)',
      'cv.image.upload.maxSize.column': 'Grafica colonna: Massimo 318 pixel (larghezza) x 1123 pixel (altezza)',
      'cv.image.upload.info': 'Seleziona una grafica che non superi queste dimensioni.',
      'cv.image.upload.alignment': 'La grafica sarà allineata a sinistra e in alto.',
      'cv.image.upload.select': 'Seleziona grafica',
      'cv.image.upload.error.tooLarge': 'Immagine troppo grande! Dimensione massima: {{maxWidth}}x{{maxHeight}} pixel. La tua immagine: {{width}}x{{height}} pixel',
      'Passgenauigkeit akzeptieren': 'Accetta il punteggio di corrispondenza',
      'CV-Vorschau öffnen': 'Apri anteprima CV',
      'Erstellungsdatum': 'Data di creazione',
    }
  },
  en: {
    translation: {
      'app.title': 'CV Optimizer',
      'app.description': 'Upload your CV and get an optimized version based on the job description.',
      'upload.cv': 'Upload CV',
      'upload.job': 'Upload job description',
      'upload.job.description': 'Upload a job description or enter it manually',
      'job.description': 'Job description',
      'job.description.placeholder': 'Describe the job you are applying for...',
      'analyze': 'Analyze',
      'download.original': 'Download original CV',
      'download.improved': 'Download improved CV',
      'download.motivation': 'Download motivation letter',
      'match.score': 'Match score',
      'missing.skills': 'Missing skills',
      'improved.cv': 'Improved CV',
      'motivation.letter': 'Motivation letter',
      'loading': 'Loading...',
      'error.upload': 'Error uploading',
      'error.analyze': 'Error analyzing',
      'error.download': 'Error downloading',
      'error.backend.api': 'Backend API URL not configured',
      'error.extract.cv': 'Error extracting CV text',
      'error.extract.cv.unknown': 'Unknown error extracting CV text: ',
      'cv.original.text': 'Original CV text',
      'cv.personal.info': 'Personal information',
      'cv.tab.data': 'CV Data',
      'cv.tab.start': 'Applications',
      'cv.tab.job.description': 'Job Description',
      'cv.tab.optimization': 'Optimization',
      'cv.subtab.applications': 'Applications',
      'cv.subtab.job.description': 'Job Description',
      'cv.subtab.optimization': 'Optimization',
      'button.next': 'Next',
      'button.back.to.applications': 'Back to my applications',
      'button.enter.job.description': 'Enter Job Description',
             'cv.personal.fullname': 'Full name',
       'cv.personal.company': 'Company',
       'cv.personal.address': 'Address',
       'cv.personal.postal.code': 'Postal code',
       'cv.personal.city': 'City',
       'cv.personal.phone': 'Phone number',
      'cv.personal.email': 'Email address',
      'cv.personal.birthyear': 'Birth year',
             'cv.personal.nationality': 'Nationality',
       'cv.personal.nationality.select': 'Please select...',
       'cv.personal.nationality.swiss': 'Swiss',
       'cv.personal.nationality.german': 'German',
       'cv.personal.nationality.austrian': 'Austrian',
       'cv.personal.nationality.french': 'French',
       'cv.personal.nationality.italian': 'Italian',
       'cv.personal.nationality.spanish': 'Spanish',
       'cv.personal.nationality.british': 'British',
       'cv.personal.nationality.american': 'American',
       'cv.personal.nationality.canadian': 'Canadian',
       'cv.personal.nationality.australian': 'Australian',
       'cv.personal.nationality.japanese': 'Japanese',
       'cv.personal.nationality.chinese': 'Chinese',
       'cv.personal.nationality.indian': 'Indian',
       'cv.personal.nationality.brazilian': 'Brazilian',
       'cv.personal.nationality.argentinian': 'Argentinian',
       'cv.personal.nationality.mexican': 'Mexican',
       'cv.personal.nationality.russian': 'Russian',
       'cv.personal.nationality.turkish': 'Turkish',
       'cv.personal.nationality.moroccan': 'Moroccan',
       'cv.personal.nationality.egyptian': 'Egyptian',
       'cv.personal.nationality.south-african': 'South African',
       'cv.personal.nationality.nigerian': 'Nigerian',
       'cv.personal.nationality.kenyan': 'Kenyan',
       'cv.personal.nationality.other': 'Other',
       'cv.personal.permit': 'Residence permit',
       'cv.personal.permit.select': 'Please select...',
       'cv.personal.civilstatus': 'Civil status',
       'cv.personal.civilstatus.select': 'Please select...',
       'cv.personal.civilstatus.single': 'Single',
       'cv.personal.civilstatus.married': 'Married',
       'cv.personal.civilstatus.divorced': 'Divorced',
       'cv.personal.civilstatus.widowed': 'Widowed',
       'cv.personal.civilstatus.registered-partnership': 'Registered partnership',
       'cv.personal.profile.picture': 'Profile picture',
       'cv.personal.profile.upload': 'Upload image',
       'cv.personal.profile.format': 'JPG, PNG (max. 2MB)',
      'cv.short.profile': 'Short profile',
      'cv.work.experience': 'Work experience',
      'cv.education': 'Education',
      'cv.certificates': 'Further education / Certificates',
      'cv.languages': 'Language skills',
      'cv.languages.language': 'Language',
      'cv.languages.level': 'Level',
      'cv.languages.level.select': 'Select level',
      'cv.languages.level.A1': 'A1 - Beginner',
      'cv.languages.level.A2': 'A2 - Elementary',
      'cv.languages.level.B1': 'B1 - Intermediate',
      'cv.languages.level.B2': 'B2 - Upper Intermediate',
      'cv.languages.level.C1': 'C1 - Advanced',
      'cv.languages.level.C2': 'C2 - Near-native proficiency',
      'cv.languages.level.native': 'Native speaker',
      'cv.it.skills': 'IT skills',
      'cv.it.skills.skill': 'Skill',
      'cv.it.skills.level': 'Level',
      'cv.it.skills.level.select': 'Select level',
      'cv.it.skills.level.beginner': 'Beginner',
      'cv.it.skills.level.intermediate': 'Intermediate',
      'cv.it.skills.level.professional': 'Professional',
      'cv.it.skills.level.expert': 'Expert',
      'cv.additional.info': 'Additional information',
      'language.select': 'Select language',
      'login.title': 'Login',
      'login.email': 'Email',
      'login.password': 'Password',
      'login.submit': 'Login',
      'login.google': 'Login with Google',
      'login.tab.login': 'Login',
      'login.tab.register': 'Register',
      'login.password.confirm': 'Confirm password',
      'login.password.mismatch': 'Passwords do not match',
      'login.password.too.short': 'Password must be at least 6 characters long',
      'login.password.requirements': 'At least 6 characters required',
      'login.password.strength': 'Password strength',
      'login.password.min.length': 'At least 6 characters',
      'login.password.recommended': '8+ characters (recommended)',
      'login.registering': 'Registering...',
      'login.logging.in': 'Logging in...',
      'login.google.logging.in': 'Google Login...',
      'login.register.button': 'Register',
      'login.error.registration': 'Registration failed',
      'login.error.login': 'Login failed',
      'login.error.google': 'Google login failed',
      'login.error.invalid.email': 'Please enter a valid email address.',
      'login.error.login.credentials': 'Incorrect email or password.',
      'login.error.register.email.in.use': 'This email address is already in use. Please sign in or use password reset.',
      'login.error.register.weak.password': 'Password is too weak. Please use at least 6 characters.',
      'login.error.too.many.requests': 'Too many attempts. Please wait a moment and try again.',
      'login.error.network': 'Network error. Please check your internet connection and try again.',
      'login.error.google.popup.closed': 'Google sign-in was canceled because the popup was closed.',
      'login.error.google.popup.blocked': 'Google popup was blocked. Please allow popups for this site.',
      'login.error.google.popup.cancelled': 'Google sign-in was canceled. Please try again.',
      'login.error.google.unauthorized.domain': 'This domain is not authorized for Google sign-in.',
      'login.error.google.invalid.continue.uri': 'Google sign-in is currently misconfigured (invalid continue URI).',
      'login.error.operation.not.allowed': 'This sign-in method is currently not enabled.',
      'login.verification.sent.title': 'Registration successful!',
      'login.verification.sent.message': 'A verification email has been sent to {{email}}. Please check your inbox and click on the confirmation link.',
      'login.verification.spam.warning': 'Important: Also check your SPAM folder!',
      'login.verification.after.message': 'After verification, you can log in with your credentials.',
      'login.verification.resend.button': 'Resend email',
      'login.verification.resending': 'Sending...',
      'login.verification.resend.success': 'Verification email has been resent! Also check your spam folder.',
      'login.verification.resend.error': 'Error resending email. Please check your password.',
      'login.verification.password.prompt': 'Please enter your password to resend the email:',
      'login.verification.required': 'Please verify your email address first. Check your inbox.',
      'login.forgot.password': 'Forgot password?',
      'login.reset.title': 'Reset password',
      'login.reset.info': 'Enter your email. If an account exists, we\'ll send instructions.',
      'login.reset.sent': 'If an account exists, we\'ve sent you an email.',
      'login.reset.submit': 'Send email',
      'login.reset.new.title': 'Set a new password',
      'login.reset.new.info': 'Enter your new password.',
      'login.reset.new.password': 'New password',
      'login.reset.new.confirm': 'Confirm password',
      'login.reset.new.submit': 'Save password',
      'login.reset.new.success': 'Your password has been changed successfully. You can now sign in.',
      'login.reset.new.error': 'The link is invalid or expired. Please request a new link.',
      'login.reset.new.mismatch': 'Passwords do not match.',
      'login.reset.new.too.short': 'Password must be at least 6 characters.',
      'login.reset.new.to.login': 'Go to login',
      'common.cancel': 'Cancel',
      'logout': 'Logout',
      'account': 'Account',
      'account.plan': 'Pricing Plan',
      'account.type': 'Account Type',
      'account.type.free': 'Free',
      'account.type.basic': 'Basic',
      'account.type.pro': 'Pro',
      'account.type.beta.testing': 'Beta-Testing',
      'account.unlimited.users': 'Unlimited users',
      'account.unlimited.cv.data.sets': 'Unlimited CV data sets',
      'account.save': 'Close',
      'account.saving': 'Saving...',
      'account.save.success': 'Account type saved successfully',
      'account.save.error': 'Error saving account type',
      'account.limit.users.reached': 'The user limit for your account type has been reached. Maximum {max} users allowed.',
      'account.limit.cvs.reached': 'The CV data set limit for your account type has been reached. Maximum {max} CV data sets allowed.',
      'account.type.change.too.many.users': 'You cannot switch to {planType} because you currently have {currentUsers} users. The {planType} plan allows a maximum of {maxUsers} users. Please remove {removeCount} user(s) first.',
      'account.type.change.too.many.cvs': 'You cannot switch to {planType} because you currently have {currentCvs} CV data sets. The {planType} plan allows a maximum of {maxCvs} CV data sets. Please remove {removeCount} CV data set(s) first.',
      'account.pdf.download.not.available.free': 'PDF download is not available in the Free plan. Please upgrade to Basic or Pro.',
      'account.upgrade.title': 'Upgrade pricing plan',
      'account.upgrade.message': 'PDF downloads are not available in the Free plan',
      'account.upgrade.description': 'Please upgrade to Basic or Pro to use PDF downloads.',
      'account.upgrade.limit.title': 'PDF limit exhausted',
      'account.upgrade.limit.message': 'You have reached your PDF limit.',
      'account.upgrade.limit.description': 'Please wait for the next billing period or upgrade to a higher plan.',
      'account.upgrade.button': 'To account',
      'account.pdf.downloads': 'PDF Downloads',
      'cv.current.dataset.tooltip': 'This is the current data set',
      'cv.share.save.and.approve': 'Save and approve',
      'cv.share.saving': 'Saving...',
      'cv.share.saved': 'Data saved',
      'account.pdf.downloads.not.included': 'No PDF Downloads',
      'account.pdf.downloads.included': 'PDF Downloads included',
      'account.subscription.until': 'Valid until',
      'account.subscription.cancels': 'Cancels on',
      'account.subscription.cancelled': 'Cancelled',
      'account.subscription.auto.renew': 'Renews automatically',
      'account.cv.data.sets': 'CV Data Sets',
      'account.users': 'Users',
      'account.users.loading': 'Loading users...',
      'account.users.none': 'No users found',
      'account.users.email': 'Email',
      'account.users.role': 'Role',
      'account.users.role.owner': 'Owner',
      'account.users.role.member': 'Member',
      'account.users.role.change.promote': 'Make owner',
      'account.users.role.change.demote': 'Remove owner status',
      'account.users.role.change.confirm.promote': 'Do you want to make this user an owner?',
      'account.users.role.change.confirm.demote': 'Do you want to remove owner status from this user?',
      'account.users.role.change.success.promote': 'User has been promoted to owner',
      'account.users.role.change.success.demote': 'Owner status has been removed',
      'account.users.role.change.error': 'Error changing user role',
      'account.users.role.change.last.owner.error': 'The last owner cannot be demoted',
      'application.responsible.person': 'Responsible Person',
      'account.invite': 'Invite User',
      'account.invite.email': 'Email Address',
      'account.invite.email.placeholder': 'email@example.com',
      'account.name': 'Account Name',
      'account.name.placeholder': 'e.g. My Company',
      'account.invite.send': 'Send Invitation',
      'account.invite.sending': 'Sending invitation...',
      'account.invite.success': 'Invitation sent',
      'account.invite.error': 'Error sending invitation',
      'account.invite.invalid.email': 'Invalid email address',
      'account.invite.email.not.sent': 'Email could not be sent automatically. Please copy the link and send it manually:',
      'account.invite.link': 'Invitation link',
      'account.invite.copy': 'Copy',
      'account.invite.link.copied': 'Link copied to clipboard',
      'account.invite.open.email': 'Open email',
      'account.invite.email.subject': 'Invitation to Curiculum Account',
      'account.invite.email.body': 'You have been invited to join a Curiculum account.\n\nClick on the following link to register and join the account:\n{link}\n\nThis link is valid for 7 days.',
      'account.invite.link.not.available': 'Error: Invitation link could not be created. Please try again.',
      'account.users.delete': 'Delete',
      'account.users.delete.confirm': 'Are you sure you want to remove this user?',
      'account.users.delete.success': 'User removed successfully',
      'account.users.delete.error': 'Error removing user',
      'account.users.delete.deleting': 'Removing user...',
      'invite.title': 'Account Invitation',
      'invite.message': 'You have been invited to join {{accountName}}. Please register to join the account.',
      'invite.loading': 'Loading invitation data...',
      'invite.invalid': 'Invalid or expired invitation link',
      'invite.error.loading': 'Error loading invitation data',
      'invite.error.register': 'Error during registration',
      'invite.error.accept': 'Error accepting invitation',
      'invite.error.google': 'Error during Google registration',
      'invite.error.email.mismatch': 'The Google email address does not match the invitation email',
      'invite.success': 'Registration successful! You will be redirected...',
      'invite.redirecting': 'Redirecting...',
      'invite.register': 'Register',
      'invite.registering': 'Registering...',
      'invite.tab.email': 'Email & Password',
      'invite.tab.google': 'With Google',
      'invite.email.info': 'Please use the email address {{email}} for registration.',
      'invite.logged.in': 'You are already logged in as {{email}}.',
      'invite.accept': 'Accept Invitation',
      'invite.accepting': 'Accepting...',
       'clear.all.data': 'Clear all data',
       'Daten speichern': 'Save data',
       'Keine Änderungen zum Speichern': 'No changes to save',
       'cv.work.experience.add': 'Add work experience',
       'cv.work.experience.period': 'Period',
       'cv.work.experience.company': 'Company',
       'cv.work.experience.position': 'Position',
       'cv.education.add': 'Add education',
       'cv.education.institution': 'Institution',
       'cv.education.degree': 'Degree',
       'cv.certification.add': 'Add certification / training',
       'cv.certification.name': 'Name',
       'cv.certification.issuer': 'Issuer',
       'cv.certification.date': 'Date',
       'cv.certification.description': 'Description',
       'cv.certification.title': 'Certification / Training',
       'cv.certification.extracted': 'Extracted certifications',
       'button.cancel': 'Cancel',
       'button.add': 'Add',
       'button.delete': 'Delete',
       'label.start': 'Start',
       'label.end': 'End',
       'extraction.uploading': 'Uploading file...',
       'extraction.processing': 'Processing CV...',
       'extraction.short.profile': 'Extracting short profile...',
       'extraction.work.experience': 'Extracting work experience...',
       'extraction.education': 'Extracting education...',
       'extraction.certifications': 'Extracting certifications...',
       'extraction.personal.info': 'Extracting personal information...',
       'extraction.fallback': 'Using local extraction...',
       'extraction.complete': 'Extraction complete!',
       'error.clear.data': 'Error clearing data: ',
       'ai.extraction.title': 'AI-assisted extraction',
       'ai.extraction.description': 'Personal data is automatically extracted with AI',
       "cv.education.title": "Education",
       "cv.education.startDate": "Start date",
       "cv.education.endDate": "End date",
       'agb.title': 'Terms and Conditions',
       'agb.welcome': 'Welcome! Please read and accept our Terms and Conditions to use the application.',
       'agb.readInstructions': 'Please read the Terms and Conditions carefully:',
       'agb.link': 'Open Terms and Conditions (new tab)',
       'agb.confirmation': 'I have read and accept the Terms and Conditions.',
       'agb.confirmation.before': 'I have read the',
       'agb.confirmation.link': 'Terms and Conditions',
       'agb.confirmation.after': 'and accept them.',
       'agb.notice': 'Note: You must accept the Terms and Conditions to use the application. You can log out at any time.',
       'agb.logout': 'Log out',
       'agb.accept': 'Accept Terms and Conditions',
       'footer.copyright': '© {{year}} acceler-8. All rights reserved.',
       'footer.impressum': 'Legal Notice',
       'footer.privacy': 'Privacy',
       'footer.terms': 'Terms',
       'impressum.title': 'Legal Notice',
       'impressum.email': 'Email',
       'impressum.registry': 'Commercial register no.',
       'impressum.country': 'Switzerland',
       'impressum.back': 'Back to home',
      'agb.accepting': 'Accepting...',
      'agb.error.loading': 'Error loading Terms and Conditions status',
      'agb.error.retry': 'Please try again or contact support.',
      'agb.error.reload': 'Reload page',
      'cv.import.warning.title': 'Important Data Quality Notice',
      'cv.import.warning.message': 'Please carefully review the extracted data!',
      'cv.import.warning.description': 'AI-based CV data extraction does not achieve 100% accuracy. Errors may occur in the recognition of:',
      'cv.import.warning.item1': 'Names, addresses and contact data',
      'cv.import.warning.item2': 'Work experiences and time periods',
      'cv.import.warning.item3': 'Education and certifications',
      'cv.import.warning.item4': 'Skills and competencies',
      'cv.import.warning.footer': 'Please correct all detected errors before proceeding with the application.',
      'cv.import.warning.button': 'Close',
      'cv.import.warning.dontShowAgain': 'Don\'t show this information again.',
      'cv.template.warning.title': 'Important Note on CV Template',
      'cv.template.warning.message': 'Please read the CV draft carefully and adapt it!',
      'cv.template.warning.description': 'AI only creates a first draft. You need to do the fine-tuning and check the following areas:',
      'cv.template.warning.item1': 'Formatting and layout',
      'cv.template.warning.item2': 'Correctness of information',
      'cv.template.warning.item3': 'Relevance for the job posting',
      'cv.template.warning.disclaimer': 'AI-generated content is draft material and must be professionally reviewed before use. No warranty is provided for completeness, accuracy, or outcomes.',
      'cv.template.warning.footer': 'Take time for a careful review before using the CV.',
      'cv.template.warning.button': 'Close',
      'cv.template.warning.dontShowAgain': 'Don\'t show this information again.',
      'cv.motivation.warning.title': 'Important note about the motivation letter',
      'cv.motivation.warning.message': 'Please read the motivation letter carefully and adapt it!',
      'cv.motivation.warning.description': 'The AI only creates a first draft. You need to do the finishing touches and check the following areas:',
      'cv.motivation.warning.item1': 'Spelling and grammar',
      'cv.motivation.warning.item2': 'Personal address and tone',
      'cv.motivation.warning.item3': 'Relevance to the job posting',
      'cv.motivation.warning.item4': 'Completeness of arguments',
      'cv.motivation.warning.footer': 'Take time for a careful revision before using the motivation letter.',
      'cv.motivation.warning.button': 'Close',
      'cv.motivation.warning.dontShowAgain': 'Don\'t show this information again.',
      'onboarding.title': 'Welcome! Please complete your profile',
      'onboarding.firstName': 'First name',
      'onboarding.lastName': 'Last name',
      'onboarding.gender': 'Gender',
      'onboarding.gender.male': 'Male',
      'onboarding.gender.female': 'Female',
      'onboarding.gender.diverse': 'Diverse',
      'onboarding.gender.unspecified': 'Not specified',
      'onboarding.country': 'Country',
      'onboarding.country.ch': 'CH - Switzerland',
      'onboarding.country.de': 'DE - Germany',
      'onboarding.country.at': 'AT - Austria',
      'onboarding.country.fr': 'FR - France',
      'onboarding.country.it': 'IT - Italy',
      'onboarding.company': 'Company (Optional)',
      'onboarding.save': 'Save',
      'onboarding.saving': 'Saving...',
      'cv.image.upload.title.header': 'Select Header Graphic',
      'cv.image.upload.title.column': 'Select Column Graphic',
      'cv.image.upload.maxSize': 'Maximum Graphic Size:',
      'cv.image.upload.maxSize.header': 'Header Graphic: Maximum 794 pixels (width) x 228 pixels (height)',
      'cv.image.upload.maxSize.column': 'Column Graphic: Maximum 318 pixels (width) x 1123 pixels (height)',
      'cv.image.upload.info': 'Please select a graphic that does not exceed these dimensions.',
      'cv.image.upload.alignment': 'The graphic will be aligned left and top.',
      'cv.image.upload.select': 'Select Graphic',
      'cv.image.upload.error.tooLarge': 'Image too large! Maximum size: {{maxWidth}}x{{maxHeight}} pixels. Your image: {{width}}x{{height}} pixels',
      'Passgenauigkeit akzeptieren': 'Accept match score',
      'CV-Vorschau öffnen': 'Open CV preview',
      'Erstellungsdatum': 'Creation date',
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['navigator', 'htmlTag', 'path', 'subdomain'],
      caches: [], // Kein Caching - Browser-Einstellungen haben immer Vorrang
    },
  });

// Funktion zum manuellen Sprachwechsel
export const changeLanguage = (language: string) => {
  i18n.changeLanguage(language);
};

// Funktion zum Ersetzen von ß durch ss für Schweizer Texte
export const replaceEsszettForSwitzerland = (text: string, country: string | null): string => {
  if (country === 'CH') {
    return text.replace(/ß/g, 'ss');
  }
  return text;
};

// Erweiterte Übersetzungsfunktion mit CH-Unterstützung
// Diese Funktion wird aktuell nicht verwendet, da die Logik direkt in App.tsx implementiert ist
// Sie wird für zukünftige Verwendung bereitgehalten
export const tWithCountry = (key: string, country: string | null, options?: any): string => {
  // Hole die aktuelle Sprache aus i18n
  const currentLang = i18n.language || 'de';
  
  // Hole die Übersetzung direkt aus dem resources-Objekt
  const translation = (resources[currentLang as keyof typeof resources]?.translation as any)?.[key] || key;
  
  // Stelle sicher, dass translation ein String ist
  const translationString = typeof translation === 'string' ? translation : String(translation);
  return replaceEsszettForSwitzerland(translationString, country);
};

export default i18n; 